export default __webpack_public_path__ + "static/media/matthew_dempsey.ea25830c.png";